<script> 
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric"; 
export default {
  mixins: [Api, Sabit],
  props: ["Data"],
  data() {
    return {
      Column:null,
      Order: null
    };
  },
  components: {

  },
  watch: {
    ColumnAndOrder: {
      handler() {
        this.OrderEmit();
      },
      deep: true,
    }
  },
  computed: {
    ColumnAndOrder() {
      return { Column: this.Column, Order: this.Order };
    }
  },
  methods: { 
    OrderEmit() {
      this.$emit("OrderBy", this.Order + "=" + this.Column);
    },
    Get() { },
  },
};
</script>
<template>
 
  <template v-for="SubData in Data" :key="SubData.label">
  <th scope="row" 
  @click="Column = Object.keys(SubData)[0], Order = Order ? Order == 'Asc' ? 'Desc' : 'Asc'  : 'Asc'"> 
    {{ SubData[Object.keys(SubData)[0]] }}  {{  Object.keys(SubData)[0] == Column  ? Order == "Asc" ? "↓" : "↑"  : "" }}  
  </th>
  </template>
</template>
